import { Icon } from '@/components/r5/glyphs'
import { R5Button } from '@/components/r5/R5Button'
import { R5Link } from '@/components/r5/R5Link'
import { t, useLanguage } from '@/lib/i18n'
import { useTaskLock } from './useTaskLock'
import './tasks.css'

/**
 * One line above the practice library while a task locks other practice (D15): the library itself is not touched. Pressing
 * Start on a locked test opens `/test/:id`, where `TaskGate` explains. Renders nothing without a lock, while the answer loads,
 * when the lookup fails, for anyone who is not a student, and in a build without the flag.
 */
export function LibraryTaskBanner() {
  useLanguage()
  const { lock } = useTaskLock()
  if (!lock) return null
  return (
    <aside className="tk-banner" role="note">
      <p className="tk-banner__text"><Icon name="lock" size={16} /><span>{t('Your other practice opens when your task is done.')}</span></p>
      <R5Button asChild variant="ghost" size="sm"><R5Link to="/home">{t('Go to your task')}</R5Link></R5Button>
    </aside>
  )
}
